// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rK7h","tabsBox":"styles_tabsBox__CSaio","createButton":"styles_createButton__EsJpv"};